module.exports = __webpack_public_path__ + "img/avatar.367c2500.png";